export default __webpack_public_path__ + "static/media/info_bonus.min.2eb6d028.png";